import {
  Box,
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  FormControl,
  FormLabel,
  VStack,
} from '@chakra-ui/react'
import { useFieldArray, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { z } from 'zod'

import {
  DialogDrawer,
  useDialogContext,
} from '@/components/shared/bundles/Drawer'
import { Inputs } from '@/components/shared/forms/Inputs'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'
import { Call } from '@/services/backend/config/entities'
import { Repository } from '@/services/repository'

interface Props {
  onSuccess: (data: Call) => void
}

const formSchema = z.object({
  description: z.string(),
  requesterName: z.string(),
  requesterPhone: z.string(),
  requesterMail: z.string(),
  files: z.array(z.any()),
})

type FormProps = z.infer<typeof formSchema>

const Component = ({ onSuccess }: Props) => {
  const { onClose } = useDialogContext()
  const { client } = useAuthStore()

  const form = useForm<FormProps>({
    defaultValues: {
      description: '',
      requesterName: '',
      requesterPhone: '',
      requesterMail: '',
      files: [],
    },
  })

  const filesArray = useFieldArray({ control: form.control, name: 'files' })

  const onSubmit = form.handleSubmit(async (data) => {
    if (!client) return toast.error('Patrimônio não encontrado')

    try {
      const res = await Repository.Entity.Call.Create({
        assetId: client.asset.id,
        description: data.description,
        requesterName: data.requesterName,
        requesterPhone: data.requesterPhone,
        requesterMail: data.requesterMail,
        files: filesArray.fields,
      })
      toast.success('Chamado criado com sucesso')
      onSuccess(res)
      onClose()
    } catch (error: any) {
      toast.error(error.message)
    }
  })

  return (
    <DialogDrawer>
      <form onSubmit={onSubmit}>
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Novo chamado</DrawerHeader>
          <DrawerBody>
            <VStack align="stretch" gap={4}>
              <FormControl isRequired>
                <FormLabel>Nome solicitante</FormLabel>
                <Inputs.Text useForm={form} useFormField="requesterName" />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Telefone</FormLabel>
                <Inputs.Mask
                  useForm={form}
                  useFormField="requesterPhone"
                  inputMask="INPUT_TELEFONE"
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>E-mail</FormLabel>
                <Inputs.Text useForm={form} useFormField="requesterMail" />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Defeito reclamado</FormLabel>
                <Inputs.Textarea useForm={form} useFormField="description" />
              </FormControl>

              <Box>
                <FormLabel>Evidências</FormLabel>
                <Inputs.ImageGallery fieldArray={filesArray} />
              </Box>
            </VStack>
          </DrawerBody>
          <DrawerFooter>
            <Button type="submit" colorScheme="primary">
              Salvar
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </form>
    </DialogDrawer>
  )
}

export default Component
